import React, { useEffect, useState } from 'react';
import attechFile2 from '../../../assets/img/ios-attach2.svg';
import documentFile from '../../../assets/img/document-file.svg';
import downloadIcon2 from 'assets/img/download-icon2.svg';
import dotsThreeIcon from 'assets/img/DotsThree.svg';
import whyIcon from '../../../assets/img/why-icon.svg';
import delete3 from 'assets/img/delete3.svg';
import contractDocument from '../../../assets/img/contract-document.svg';
import { Dropdown } from 'react-bootstrap';
import copylink from 'assets/img/copylink.svg';
import {
  handleDownloadPdf,
  MAX_FILE_SIZE,
  selectLoader,
  userNameLimit,
  validateTextInput
} from '../../../utils/Helpers';
import appToast, { TOAST_TYPE } from '../../../utils/AppToast';
import APIServices from '../../../services/APIServices';
import Tippy from '@tippyjs/react';
import ConfirmModal from 'components/ConfirmModal';

const RequestModal = ({ projectId = '', requestId = '', closeModal, onCloseRequestModal }) => {
  const [formData, setFormData] = useState({
    projectId: projectId || '',
    title: '',
    description: '',
    changeRequestDeadline: '',
    attachments: [],
    requestType: 'change_request'
  });
  const [files, setFiles] = useState([]);
  const [isEditing, setEditing] = useState(false);
  const [filesToDelete, setFilesToDelete] = useState([]);
  const [requestDetails, setRequestDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [isOutOfScope, setIsOutOfScope] = useState(false);
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const [selectedAttachment, setSelectedAttachment] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [severityLevel, setSeverityLevel] = useState('');
  const [currentRequestId, setCurrentRequestId] = useState(requestId || '');
  const [actionLoading, setActionLoading] = useState('');
  const [scopeExplanation, setScopeExplanation] = useState(
    'This request may be considered out of scope. Please ensure it aligns with supported request types before submitting.'
  );
  const [referencedClauses, setReferencedClauses] = useState([]);
  const [modals, setModals] = useState({
    closeConfirmModal: false
  });

  const toggleModal = (modalType, isOpen) => {
    setModals((prevState) => ({
      ...prevState,
      [modalType]: isOpen
    }));
  };
  useEffect(() => {
    if (requestId) {
      setEditing(true);
      fetchRequestDetails();
      console.log(requestId);
    }
  }, [requestId]);

  useEffect(() => {
    const modal = document.querySelector('.updatedRequest-modal');

    if (modal) {
      if (isOutOfScope) {
        modal.classList.add('modal-wide');
      } else {
        modal.classList.remove('modal-wide');
      }
    }
  }, [isOutOfScope]);

  useEffect(() => {
    const handleClose = () => {
      handleModalCloseClick();
    };

    document.addEventListener('requestModalClose', handleClose);

    return () => {
      document.removeEventListener('requestModalClose', handleClose);
    };
  }, [currentRequestId]);

  useEffect(() => {
    if (requestDetails) {
      console.log(requestDetails);
      setFormData((prevData) => ({
        ...prevData,
        description: requestDetails?.description,
        title: requestDetails?.title,
        attachments: requestDetails?.attachments,
        changeRequestDeadline: requestDetails?.changeRequestDeadline > 0 ? requestDetails?.changeRequestDeadline : ''
      }));
      setFiles(requestDetails?.attachments);
    }
  }, [requestDetails]);

  const copyLink = async (url) => {
    await navigator.clipboard.writeText(url);
    setOpenDropdownId(null);
    appToast('Link copied!', TOAST_TYPE.SUCCESS);
  };

  //fetch request details while updating/editing request
  const fetchRequestDetails = async () => {
    setPageLoading(true);
    try {
      let response = await APIServices.get(`/project-requests/detail/${requestId}`);
      if (response.data) {
        setRequestDetails(response.data);
      }
    } catch (error) {
      console.error('Error fetching milestones:', error);
    } finally {
      setPageLoading(false);
    }
  };

  // Handle file upload
  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    handleFiles(selectedFiles);
  };

  // Handle file removal
  const handleRemoveFile = (index) => {
    if (isEditing) {
      let fileToDelete = files.filter((_, i) => i === index);
      if (fileToDelete && fileToDelete.length > 0 && fileToDelete[0]._id) {
        setFilesToDelete((prevFiles) => [...prevFiles, fileToDelete[0]._id]);
      }
    }

    const updatedFiles = files.filter((_, i) => i !== index);
    setFiles(updatedFiles);
  };

  // Handle input changes and remove error
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const updatedValue = name === 'changeRequestDeadline' ? value.replace(/[^0-9.]/g, '') : value;

    // ✅ Check meaningful change (ignore spaces)
    if (name === 'title' || name === 'description') {
      const oldValue = formData[name] || '';

      if (oldValue.trim() !== updatedValue.trim()) {
        setIsOutOfScope(false);
        setScopeExplanation('');
      }
    }

    setFormData((prevData) => ({
      ...prevData,
      [name]: updatedValue
    }));

    if (errors[name]) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: null
      }));
    }
  };

  // Form validation
  const validateForm = () => {
    let formErrors = {};

    if (!validateTextInput(formData.title).isValid) {
      if (!validateTextInput(formData.title).cleanedValue) {
        formErrors.title = 'Please enter request title.';
      } else {
        formErrors.title = validateTextInput(formData.title).message;
      }
    }

    // if (!validateTextInput(formData.description).isValid) {
    //   if (!validateTextInput(formData.description).cleanedValue) {
    //     formErrors.description = "Please enter description.";
    //   } else {
    //     formErrors.description = validateTextInput(
    //       formData.description
    //     ).message;
    //   }
    // }

    // if (formData.changeRequestDeadline === "") {
    //   formErrors.changeRequestDeadline =
    //     "Days needed for response is required.";
    // }
    // if (files.length === 0) {
    //   formErrors.files = "At least one attachment is required.";
    // }

    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  // Handle form submission
  const handleSubmit = async () => {
    if (!validateForm()) return;

    setLoading(true);
    setActionLoading('submit');
    const formDataToSend = new FormData();

    Object.entries(formData).forEach(([key, value]) => {
      if (key !== 'attachments') {
        formDataToSend.append(key, value);
      }
    });

    files.forEach((file) => {
      formDataToSend.append('attachments', file);
    });

    if (isEditing && filesToDelete.length > 0) {
      formDataToSend.append('deletedAttachments', filesToDelete.join(','));
    }

    // 👉 IMPORTANT: add allowOutOfScope when retrying
    if (isOutOfScope) {
      formDataToSend.append('allowOutOfScope', true);
    }

    try {
      const response = isEditing
        ? await APIServices.put(`/project-requests/${currentRequestId || requestId}`, formDataToSend, {
            'Content-Type': 'multipart/form-data'
          })
        : await APIServices.post('/project-requests', formDataToSend, {
            'Content-Type': 'multipart/form-data'
          });

      // ✅ CASE 1: Out of scope response
      // ✅ CASE 1: Out of scope response (UPDATED)
      if (response?.data?.scopeReview?.scopeStatus && response?.data?.scopeReview?.scopeStatus != 'IN_SCOPE') {
        setIsOutOfScope(true);

        // ✅ IMPORTANT: mark as editing
        setEditing(true);

        // ✅ store ID
        setCurrentRequestId(response?.data?._id);

        setScopeExplanation(response?.data?.scopeReview?.summary || response?.data?.scopeReview?.reasoning || '');

        setSeverityLevel(response?.data?.scopeReview?.severityLevel || 'medium');
        setReferencedClauses(response?.data?.scopeReview?.referencedClauses || []);
        return;
      }

      // ✅ CASE 2: Success
      if (response.message) {
        appToast(response.message, TOAST_TYPE.SUCCESS);
        closeModal();
      } else if (response.data?.message) {
        appToast(response.data.message, TOAST_TYPE.ERROR);
      }
    } catch (error) {
      console.error('Error submitting change order request:', error);
    } finally {
      setLoading(false);
      setActionLoading('');
    }
  };
  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const droppedFiles = Array.from(e.dataTransfer.files);

    handleFiles(droppedFiles);
  };

  const handleFiles = (selectedFiles) => {
    const totalFiles = files.length + selectedFiles.length;

    if (totalFiles > 5) {
      appToast('You can upload a maximum of 5 files.', TOAST_TYPE.ERROR);
      return;
    }

    const totalSize =
      files.reduce((sum, file) => sum + file.size, 0) + selectedFiles.reduce((sum, file) => sum + file.size, 0);

    if (totalSize > 40 * 1024 * 1024) {
      appToast('The total size of uploaded files should not exceed 40MB.', TOAST_TYPE.ERROR);
      return;
    }

    setFiles((prev) => [...prev, ...selectedFiles]);
  };

  const handleConvertToChangeOrder = async () => {
    try {
      // appToast('Coming soon', TOAST_TYPE.WARNING);
      // return;
      setActionLoading('changeOrder');

      const res = await APIServices.put(`/project-requests/convert/${currentRequestId}/changeorder`);

      appToast(res?.message || 'Converted to change order', TOAST_TYPE.SUCCESS);
      closeModal();
    } catch (err) {
      console.error(err);
      appToast('Failed to convert to change order', TOAST_TYPE.ERROR);
    } finally {
      setActionLoading('');
    }
  };

  const handleAskForReview = async () => {
    try {
      setActionLoading('review');
      const res = await APIServices.put(`/project-requests/${currentRequestId}/request-review`);

      appToast(res?.message || 'Review requested', TOAST_TYPE.SUCCESS);
      closeModal();
    } catch (err) {
      console.error(err);
      appToast('Failed to request review', TOAST_TYPE.ERROR);
    } finally {
      setActionLoading('');
    }
  };

  const handleWithdrawRequest = async () => {
    try {
      setActionLoading('withdraw');

      const res = await APIServices.put(`/project-requests/${currentRequestId}/update-status`, {
        status: 'withdrawn'
      });

      appToast(res?.message || 'Request withdrawn', TOAST_TYPE.SUCCESS);

      toggleModal('closeConfirmModal', false);
      onCloseRequestModal(); // ✅ close main modal
    } catch (err) {
      console.error(err);
      appToast('Failed to withdraw request', TOAST_TYPE.ERROR);
    } finally {
      setActionLoading('');
    }
  };

  const handleUpdateRequestClick = () => {
    setIsOutOfScope(false);
    setScopeExplanation('');
    setEditing(true);
  };

  const handleModalCloseClick = () => {
    // Only trigger withdraw if request exists
    if (currentRequestId) {
      toggleModal('closeConfirmModal', true);
    } else {
      // No request created yet → just close
      onCloseRequestModal();
    }
  };

  const closeConfirmContent = (
    <div>
      <h2 className="mb-3">Are you sure?</h2>
      <h3>You want to withdraw this request? </h3>
    </div>
  );

  if (pageLoading) {
    return <div className="nodata-loader"> {selectLoader(60)}</div>;
  }

  return (
    <div
      className={`general-request-modal-body ${isOutOfScope ? 'with-right-sec' : 'full-width'} ${actionLoading === 'submit' ? 'opacity05' : ''}`}>
      <div className="general-request-modal">
        <div className='overflow-container'>
        <div className="row mt-3">
          <div className="col-lg-12">
            <div className="form-group">
              <label className="mb-1">Request Title</label>
              <input
                maxLength={userNameLimit}
                type="text"
                className={`form-control ${errors.title ? 'form-invalid' : ''}`}
                name="title"
                placeholder="e.g., Add Dark Mode to Dashboard"
                value={formData.title}
                onChange={handleInputChange}
              />
              {errors.title && <small className="text-danger">{errors.title}</small>}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="form-group">
              <label className="mb-1">What would you like us to do?</label>
              <textarea
                style={{ maxHeight: '320px' }}
                placeholder="Describe your request in detail. Include any specific requirements, expected behavior, or references to existing features."
                className={`form-control ${errors.description ? 'form-invalid' : ''}`}
                name="description"
                value={formData.description}
                onChange={(e) => {
                  handleInputChange(e);
                  e.target.style.height = 'auto'; // Reset the height
                  e.target.style.height = `${e.target.scrollHeight + 2}px`; // Set the height to fit content
                }}></textarea>
              {/* {errors.description && (
              <small className="text-danger">{errors.description}</small>
            )} */}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="form-group signoff_days">
              <label className="mb-1">Days needed for response?</label>
              <input
                type="text"
                className={`form-control ${errors.changeRequestDeadline ? 'form-invalid' : ''}`}
                name="changeRequestDeadline"
                placeholder="e.g., 3days"
                value={formData.changeRequestDeadline}
                onChange={(e) => {
                  console.log(e);
                  const validValue = e.target.value.replace(/[^0-9.]/g, '');

                  if (validValue <= 100) {
                    handleInputChange(e);
                  } else if (validValue > 100) {
                    appToast('The Days needed for response must not exceed 100.', TOAST_TYPE.WARNING);
                  }
                }}
              />
              {formData.changeRequestDeadline && (
                <span className="days-value">day{formData.changeRequestDeadline > 1 && 's'}</span>
              )}
              {errors.changeRequestDeadline && <small className="text-danger">{errors.changeRequestDeadline}</small>}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <label className="mb-1">Attachments (Optional)</label>

            <div className={`cardbg-form-group`}>
              <div
                className={`attech-file-cover ${isDragging ? 'drag-active' : ''}`}
                onDrop={(e) => {
                  handleDrop(e);
                  setIsDragging(false);
                }}
                onDragOver={(e) => e.preventDefault()}
                onDragEnter={() => setIsDragging(true)}
                onDragLeave={() => setIsDragging(false)}>
                <img src={attechFile2} alt="Attach" className="attechFile" />
                <a className="attech-btn">
                  <p> Drop files here or click to upload</p>

                  <label className="add-btn-text cursor_pointer">
                    <input
                      type="file"
                      multiple
                      accept="image/*"
                      onChange={handleFileChange}
                      style={{ display: 'none' }}
                    />
                    + Screenshots, mockups, or reference documents
                  </label>
                </a>
              </div>

              {errors.files && <small className="text-danger">{errors.files}</small>}
            </div>
          </div>
          {/* <div className="row">
            <div className="col-lg-12">
              {isOutOfScope && scopeExplanation && (
                <div className="explaination-text" style={{ fontSize: '13px' }}>
                  <span>
                    <b>Important:</b> {scopeExplanation}
                  </span>
                </div>
              )}
            </div>
          </div> */}
        </div>

        <div className="file_grid_row_attechment">
          <div className="file_grid_row row">
            {files.map((item, index) => {
              const uniqueId = item.id || index;

              return (
                <div className="col-lg-4 col-md-6 col-sm-6">
                  <div className="file_card">
                    <div className="file_preview">
                      <a href="" target="_blank">
                        <img src={documentFile} alt="File" className="documentFile" />
                      </a>
                    </div>

                    <div className="file_info">
                      <div className="file_info_content">
                        <Tippy
                          // content={`Color: ${namer(x.color).ntc[0].name}, title: ${x?.name}`}
                          // content={item.name}
                          placement="top"
                          arrow={true}>
                          <div className="file_name">{item.name}</div>
                        </Tippy>
                        <div className="file_time">14 min ago</div>
                      </div>
                      <div className="delete_file_icon">
                        <img
                          src={delete3}
                          alt="menu"
                          onClick={() => {
                            handleRemoveFile(index);
                            setSelectedAttachment(item);
                            setShowDeleteModal(true);
                            setOpenDropdownId(null);
                          }}
                          // className="file_menu"
                          // onClick={() => setOpenDropdownId(uniqueId)}
                        />
                      </div>
                      {/* <Dropdown align="end" show={openDropdownId === uniqueId} onToggle={() => {}}>
                        <Dropdown.Toggle
                          as="span"
                          className="file_menu"
                          id={`dropdown-${uniqueId}`}
                          onClick={(e) => {
                            e.stopPropagation();
                            setOpenDropdownId((prev) => (prev === uniqueId ? null : uniqueId));
                          }}>
                          <img src={dotsThreeIcon} alt="menu" />
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                          <Dropdown.Item onClick={() => copyLink(item.preview)}>
                            <img src={copylink} alt="copylink" className="featherdrowpdown-icon" />
                            Copy Link
                          </Dropdown.Item>

                          <Dropdown.Item onClick={() => handleDownloadPdf(item.preview, item.name)}>
                            <img src={downloadIcon2} alt="download" className="featherdrowpdown-icon" />
                            Download
                          </Dropdown.Item>

                          <Dropdown.Item
                            onClick={() => {
                              handleRemoveFile(index);
                              setSelectedAttachment(item);
                              setShowDeleteModal(true);
                              setOpenDropdownId(null);
                            }}
                            className="text-danger">
                            <img src={delete3} alt="delete" className="featherdrowpdown-icon" />
                            Delete
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown> */}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        </div>
      
      <div className="row">
        <div className="col-lg-12">
          <div className="form-group-btn-btm">
            {isOutOfScope && <label>What would you like to do?</label>}
            <div className="form-group-btn-cover">
              <button
                className="btn-black"
                onClick={isOutOfScope ? handleUpdateRequestClick : handleSubmit}
                disabled={loading}>
                {actionLoading === 'submit' ? (
                  <div className="btn-loader">
                    {selectLoader(20)}
                    {!isOutOfScope && <span>Processing your request...</span>}
                  </div>
                ) : isEditing ? (
                  isOutOfScope ? (
                    'Update Request'
                  ) : (
                    'Update'
                  )
                ) : isOutOfScope ? (
                  'Update Request'
                ) : (
                  'Submit'
                )}
              </button>
              {isOutOfScope && (
                <>
                  <button className="btn-black" onClick={handleConvertToChangeOrder} disabled={!!actionLoading}>
                    {actionLoading === 'changeOrder' ? selectLoader(20) : 'Submit Change Order'}
                  </button>

                  <button className="btn-black" onClick={handleAskForReview} disabled={!!actionLoading}>
                    {actionLoading === 'review' ? selectLoader(20) : 'Ask for Review'}
                  </button>

                  <button
                    className="btn-black"
                    onClick={() => toggleModal('closeConfirmModal', true)}
                    disabled={!!actionLoading}
                    // disabled={isOutOfScope}
                  >
                    {actionLoading === 'withdraw' ? selectLoader(20) : 'Withdraw Request'}
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      </div>
      {isOutOfScope && (
        <div className="general-request-modal-rightSec">
          <div className="row mt-3">
            <div className="col-lg-12">
              <div className="form-group">
                <label>Scope Analysis</label>
                <div
                  className={`scope-analysis-box scope-analysis-box-bgColor ${
                    severityLevel?.toLowerCase() === 'high'
                      ? 'scope-high'
                      : severityLevel?.toLowerCase() === 'medium'
                        ? 'scope-medium'
                        : 'scope-low'
                  }`}>
                  <div className="scope-analysis-title">
                    <h2>
                      <span>
                        {severityLevel.toLowerCase() === 'high'
                          ? 'High:'
                          : severityLevel.toLowerCase() === 'medium'
                            ? 'Medium:'
                            : 'Low:'}
                      </span>{' '}
                      This request is outside the current project scope.
                    </h2>
                  </div>
                  <p>This may impact timeline and/or cost</p>
                </div>
              </div>
              <div className="form-group">
                <div className="scope-analysis-box">
                  <div className="scope-analysis-title">
                    <img src={whyIcon} alt="whyIcon" className="whyIcon" />
                    <h2>Why</h2>
                  </div>
                  <p>
                    {scopeExplanation
                      ? scopeExplanation
                      : 'The request description or details indicate that it may not align with the agreed-upon project scope. Please review the request and ensure it fits within the defined parameters of the project.'}
                  </p>
                </div>
              </div>
              <div className="form-group">
                <div className="scope-analysis-box">
                  <div className="scope-analysis-title">
                    <img src={contractDocument} alt="whyIcon" className="contractDocument" />
                    <h2>Contract Reference</h2>
                  </div>
                  <p className="contract-text">
                    {referencedClauses && referencedClauses.length > 0
                      ? referencedClauses.map((clause, index) => <div key={index}>{clause}</div>)
                      : 'No specific contract clauses referenced.'}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <ConfirmModal
        show={modals.closeConfirmModal}
        onHide={() => {
          toggleModal('closeConfirmModal', false);
        }}
        confirmationText={closeConfirmContent}
        handleAction={() => handleWithdrawRequest()} // Pass the deletion logic here
        loading={actionLoading === 'withdraw'}
        closeText="Yes"
      />
    </div>
  );
};

export default RequestModal;
